<template>
    <div class="col-lg-6 mb-4">
        <div class="box">
            <div class="box-offset">
                <div class="box-ttl-wrap">
                    <div class="box-ttl">Today's Standby List <span class="box-ttl-number-box">{{getDayToday()}}</span></div>
                </div>
                <div class="table-holder table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th></th>
                            <th>Name</th>
                            <th>Stage</th>
                            <th class="text-right">View</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr
                            v-for="applicant in listOfStandBy"
                            :key="applicant.id"
                        >
                            <td class="avatar-col">
                                <div class="user-info">
                                    <div
                                        class="avatar"
                                        :style="{'background-image': applicant.avatar ?  `url('/uploads/${applicant.avatar}')` : 'url(/img/svg/emptyAvatar.png)'}"
                                    ></div>
                                </div>
                            </td>
                            <td>
                                <div class="user-info">
                                    <a
                                        class="name"
                                        :href="`/master-admin/applicants/${applicant.id}/show?tab=Availability`"
                                    >{{applicant.name}} {{applicant.last_name}}
                                    </a>
                                    <div class="small-text">
                                        {{ (showAvailableShift(applicant) + ' shift') ?? '' }}
                                    </div>
                                </div>
                            </td>
                            <td>
                                {{applicant.stages}}
                            </td>
                            <td class="text-right">
                                <a  :href="`/master-admin/applicants/${applicant.id}/show?tab=Availability`"
                                    class="color--secondary"><i class="fas fa-eye"></i>
                                </a>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="text-center">
                    <a href="/master-admin/stand-by-list" class="link">View All</a>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import DashboardService from "./DashboardService";
import DateConverter from "../../../../../resources/js/mixins/DateConverter";
import AvailabilityHandler from "../../../../../resources/js/mixins/AvailabilityHandler";

export default {
    name: 'StandByListBoard',
    mixins: [DateConverter, AvailabilityHandler],
    data() {
        return {
            listOfStandBy: [],
            filters: {
                day: this.getDayOfWeek().toLowerCase(),
            }
        }
    },
    methods: {
        async getListOfStandBy() {
            try {
                const {data: response } = await DashboardService.getStandByInfo(this.filters)
                this.listOfStandBy = response
            } catch (e) {

            }
        }
    },
    mounted() {
        this.getListOfStandBy()
    }

}

</script>


<style scoped>

</style>
